module.exports = "<div class=\"loggedin-cashier\">\r\n    {showCashier | show}\r\n</div>";